import type { CoachChatConfig } from 'bundles/unified-common/providers/CoachStateProvider';
import { useSpecializationPageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';

type UseSpecializationContextConfigProps = {
  coachModeId: string;
  coachActionId: string;
};

const useSpecializationContextConfig = ({
  coachModeId,
  coachActionId,
}: UseSpecializationContextConfigProps): CoachChatConfig | undefined => {
  const specializationPageData = useSpecializationPageData();

  const careerGrowthInPercentage = specializationPageData?.careerOutcomes?.careerGrowthInPercentage?.toString() ?? '';

  if (!specializationPageData) {
    return undefined;
  }

  const config = {
    courseraContext: {
      specializationId: specializationPageData.id,
    },
    config: {
      coachModeId,
      coachActionId,
    },
    additionalContext: [
      {
        contextKey: 'additionalContext.productSlug',
        contextValue: specializationPageData.slug,
      },
      {
        contextKey: 'additionalContext.productType',
        contextValue: 'SPECIALIZATION',
      },
      ...(careerGrowthInPercentage
        ? [
            {
              contextKey: 'additionalContext.careerGrowthInPercentage',
              contextValue: `percentage-of-certificate-grads-report-career-improvement: ${careerGrowthInPercentage}%`,
            },
          ]
        : []),
    ],
  };

  return config;
};

export default useSpecializationContextConfig;
